module.exports = __webpack_public_path__ + "static/media/icon_phone.7bfc3573.svg";